var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M4 14a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M6 8a6 6 0 1 1 12 0v4h-2V8a4 4 0 0 0-8 0v4H6z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M12.05 15.01c-.69 0-1.25.56-1.25 1.25V18h2.5v-1.74c0-.69-.56-1.25-1.25-1.25"
  })));
};
export { SvgLock as Icon };
export default __webpack_public_path__ + "static/media/b1d2b8f01e9ff7e813ef4de7f97377ae.svg";